/**
 *
 * @author Matthew Rawson @ 14/08/2018 15:00
 * @description
 * @notes
 * - Left as class to future proof
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import {Col, Row} from "react-bootstrap"
import {withRouter} from "react-router-dom"

import id from "@irati/utils/id/index"
import {injectIntl} from "@irati/utils/lang/index"
import Markdown from "@irati/ui/src/Markdown/index"
import {SendToAll, TeamsIds} from "@irati-web/fields/schedule"
import {AccordionItem} from "@irati/ui/src/Accordion"

import {ACCORDION_ITEMS} from "../../../utils/constants/wizard"
import {EmailSection, FrequencySection, ReferenceSection, CustomFrequencySection} from "../../../components/Wizard"
import isCycleCustom from "../../../helpers/cycle/isCycleCustom"
import QuestionLibrary from "./QuestionLibrary"


class Edit extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    formatMessage: PropTypes.func.isRequired,
    form: PropTypes.object,
    onChange: PropTypes.func,
    cycle: PropTypes.object
  }

  static defaultProps = {
    form: {},
    cycle: {},
    onChange: () => null
  }

  constructor(props) {
    super(props)
    this.state = {
      formattedMessages: null
    }
    this.state.formattedMessages = this.generateFormattedMessages(false)

    this.items = {}
  }

  componentDidMount() {
    const {hash} = this.props.location
    this.focusItem(hash.replace("#", ""))
  }

  componentDidUpdate(prevProps) {
    const {location} = this.props
    const {hash} = location
    const prevHash = prevProps.location.hash
    if (hash !== prevHash) {
      this.focusItem(hash.replace("#", ""))
    }
  }

  focusItem = (item) => {
    this.openItem(item)
    this.scrollToItem(item)
  }

  openItem = (item) => {
    const itemRef = this.items[item]
    if (itemRef) itemRef.open()
  }
  scrollToItem = (item) => {
    const itemRef = this.items[item]
    if (itemRef) {
      itemRef.container.current.scrollIntoView({behavior: "smooth", block: "center"})
    }
  }

  closeItems = () => {
    return Promise.all(Object.values(this.items).map((item) => item.close()))
  }

  generateFormattedMessages = (setToState = true) => {
    const {formatMessage} = this.props

    const formattedMessages = {
      cycleReference: formatMessage({id: "insights.wizard.step2.accordionItem.surveyName"}),
      companyNameDescription: formatMessage({id: "insights.wizard.step2.accordionItem1.companyName.description"}),
      companyNameLabel: formatMessage({id: "insights.wizard.step2.accordionItem1.companyName.label"}),
      accordion1Title: formatMessage({id: "insights.wizard.step2.accordionItem1.title"}),
      accordion2Title: formatMessage({id: "insights.wizard.step2.accordionItem2.title"}),
      accordion3Title: formatMessage({id: "insights.wizard.step2.accordionItem3.title"}),
      accordion4Title: formatMessage({id: "insights.wizard.step2.accordionItem4.title"}),
      accordion5Title: formatMessage({id: "insights.wizard.step2.accordionItem5.title"}),
      accordion4Description: formatMessage({id: "insights.wizard.step2.accordionItem4.description"})
    }

    if (setToState) this.setState({formattedMessages})

    return formattedMessages
  }

  render() {
    const idNamespace = id("Edit", this.props, {force: true})
    const {formattedMessages} = this.state
    const {form, onChange, cycle} = this.props
    const {preferences: {sendToAll} = {}} = form
    const {lastTriggeredAt} = cycle
    const disabled = isCycleCustom(cycle) && !!lastTriggeredAt

    return (
      <>
        <AccordionItem
          ref={(ref) => {
            this.items[ACCORDION_ITEMS.cycleReference] = ref
          }}
          id={id(ACCORDION_ITEMS.cycleReference, idNamespace)}
          title={formattedMessages.cycleReference}>

          <ReferenceSection disabled={disabled} cycle={form} onChange={onChange} />
        </AccordionItem>

        <AccordionItem
          ref={(ref) => {
            this.items[ACCORDION_ITEMS.questionLibrary] = ref
          }}
          id={id(ACCORDION_ITEMS.questionLibrary, idNamespace)}
          title={formattedMessages.accordion1Title}>

          <QuestionLibrary disabled={disabled} />
        </AccordionItem>
        {isCycleCustom(cycle) && <CustomFrequencySection />}

        <AccordionItem
          ref={(ref) => {
            this.items[ACCORDION_ITEMS.frequencyAndTimeframe] = ref
          }}
          id={id("frequencyAndTimeframe", idNamespace)}
          title={formattedMessages.accordion2Title}>

          <FrequencySection
            id={idNamespace}
            disabled={disabled}
            form={form}
            cycle={cycle}
            onChange={onChange} />

        </AccordionItem>

        <AccordionItem
          ref={(ref) => {
            this.items[ACCORDION_ITEMS.emails] = ref
          }}
          id={id("emails", idNamespace)}
          title={formattedMessages.accordion3Title}>

          <EmailSection
            id={id("emails", idNamespace)}
            form={form}
            disabled={disabled}
            onChange={onChange} />

        </AccordionItem>

        <AccordionItem
          ref={(ref) => {
            this.items[ACCORDION_ITEMS.participants] = ref
          }}
          id={id("participants", idNamespace)}
          title={formattedMessages.accordion4Title}>

          <Row>
            <Col xs={12}>
              <SendToAll
                id={idNamespace}
                disabled={disabled}
                title={<Markdown id={id("participants", idNamespace)} source={formattedMessages.accordion4Description} />}
                schedule={form}
                onChange={onChange} />
            </Col>
          </Row>
          {!sendToAll && <Row> <TeamsIds isDisabled={disabled} id={idNamespace} schedule={form} onChange={onChange} /> </Row>}
        </AccordionItem>
        </>
    )
  }
}

export default injectIntl(withRouter(Edit), {withRef: true})
